
const firebaseConfig = {
    apiKey: "AIzaSyC9uzzz8RPmLjW_C5qChz94YPwDH0OHo5M",
    authDomain: "life-care-84c8f.firebaseapp.com",
    projectId: "life-care-84c8f",
    storageBucket: "life-care-84c8f.appspot.com",
    messagingSenderId: "626117810501",
    appId: "1:626117810501:web:0b4877e0a330adfc38862c",
    measurementId: "G-CS1V3PHDTK"
  };

  export default firebaseConfig;